import { useCallback, useEffect, useRef, useState } from 'react';

export const useBlockchainPolling = (enabled: boolean, refresh: () => Promise<void>) => {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;
  const start = useRef(Date.now());
  const inFlight = useRef(false);
  const [paused, setPaused] = useState(false);
  const restart = useCallback(() => { start.current = Date.now(); setPaused(false); }, []);

  useEffect(() => {
    restart();
    if (!enabled) return;
    let active = true;
    const poll = async () => {
      if (!active || document.hidden || inFlight.current) return;
      if (Date.now() - start.current >= 30 * 60_000) { setPaused(true); return; }
      inFlight.current = true;
      try { await refreshRef.current(); } finally { inFlight.current = false; }
    };
    const resume = () => {
      if (!document.hidden) { restart(); void poll(); }
    };
    const timer = window.setInterval(() => void poll(), 30_000);
    document.addEventListener('visibilitychange', resume);
    window.addEventListener('focus', resume);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', resume);
      window.removeEventListener('focus', resume);
    };
  }, [enabled, restart]);
  return { paused, restart };
};
